import { Component, Input, OnChanges, OnInit, QueryList, SimpleChanges, ViewChildren } from '@angular/core';

import { Fcd, FcdSegment, SubTrajectorySegment } from 'app/models/fcd';
import { FcdComponent } from 'app/shared/fcd/fcd.component';
import { CbmInputStyle } from 'app/shared/input/cbm-input-style';

@Component({
  selector: 'linear-details-fcd',
  templateUrl: './linear-details-fcd.component.html',
  styleUrls: ['./linear-details-fcd.component.scss']
})
export class LinearDetailsFcdComponent implements OnInit, OnChanges {
  @Input() fcdData: Fcd;
  @Input() inputStyle: CbmInputStyle;
  @Input() readonly: boolean;

  @ViewChildren(FcdComponent) fcdComponents: QueryList<FcdComponent>;

  public collapsed: boolean;
  public readonlyTrajectoryFreeFlowSpeed: boolean;

  constructor() {}

  ngOnInit(): void {
    this.collapsed = false;
    this.setReadonlyTrajectoryFreeFlowSpeed();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setReadonlyTrajectoryFreeFlowSpeed();
  }

  public setReadonlyTrajectoryFreeFlowSpeed(): void {
    if (this.fcdData.trajectoryFreeFlowSpeed === 0) {
      this.readonlyTrajectoryFreeFlowSpeed = this.readonly;
    } else {
      this.readonlyTrajectoryFreeFlowSpeed = true;
    }
  }

  public collapseAll() {
    this.collapsed = !this.collapsed;
    this.fcdComponents.forEach(fc => fc.collapse(this.collapsed));
  }

  public onDeleteFcdSegement(index: number): void {
    this.fcdData.subTrajectorySegments.splice(index, 1);
  }

  public onAddFcdSegement(index: number): void {
    const newSubTrajectorySegment = new SubTrajectorySegment();
    const fcdSegments = new FcdSegment();
    newSubTrajectorySegment.fcdSegments = [fcdSegments];
    newSubTrajectorySegment.manual = true;
    if (this.fcdData.subTrajectorySegments.length === 1 && !this.fcdData.subTrajectorySegments[0]) {
      this.fcdData.subTrajectorySegments.splice(index, 1, newSubTrajectorySegment);
    } else {
      this.fcdData.subTrajectorySegments.splice(index + 1, 0, newSubTrajectorySegment);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/linear-details/fcd/linear-details-fcd.component.ts